import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ReactEcharts from 'echarts-for-react';
import Card from '@material-ui/core/Card';

const useStyles = makeStyles((theme) => ({}));

const StyledTableRow = withStyles((theme) => ({
    
}))(TableRow);

//Start MidClassificationCombined component code..
const ClassificationChart = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const [myOptions, setmyOptions] = React.useState({});
    const [timeArr, setTimeArr] = React.useState([
        '12:00 AM', '1:00 AM', '2:00 AM', '3:00 AM', '4:00 AM', '5:00 AM', '6:00 AM', '7:00 AM', '8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM', '7:00 PM', '8:00 PM', '9:00 PM', '10:00 PM', '11:00 PM'])
    const [tableData, setTableData] = React.useState([]);
    const [tableHeader, setTableHeader] = React.useState([]);
    const [dashedArray, setDashedArray] = React.useState([]);
    const [headerClass, setHeaderClass] = React.useState(['Motor-cycles','Cars & trailer','2 Axle long','Buses','2 Axle 6 tire','3 Axle single','4 Axle single','<5 Axle double','5 Axle double','>6 Axle double','<6 Axle multi','6 Axle multi','>6 Axle multi','Not classified']);
    const [headerClassChart, setHeaderClassChart] = React.useState(['1. Motorcycles','2. Cars & trailer','3. 2 Axle long','4. Buses','5. 2 Axle 6 tire','6. 3 Axle single','7. 4 Axle single','8. <5 Axle double','9. 5 Axle double','10. >6 Axle double','11. <6 Axle multi','12. 6 Axle multi','13. >6 Axle multi','14. Not classified']);    
    const [headerClassBase, setHeaderClassBase] = React.useState(['Motorcycles','Passenger Cars','Other Two-Axle Four-Tire Single-Unit Vehicles','Buses','Two-Axle, Six-Tire, Single-Unit Trucks','Three-Axle Single-Unit Trucks','Four or More Axle Single-Unit Trucks','Four or Fewer Axle Single-Trailer Trucks','Five-Axle Single-Trailer Trucks','Six or More Axle Single-Trailer Trucks','Five or Fewer Axle Multi-Trailer Trucks','Six-Axle Multi-Trailer Trucks','Seven or More Axle Multi-Trailer Trucks','Unclassified']);
    // const [legends, setLegends] = React.useState([]);
    let legends = [];
    React.useEffect(() => {
        let maxYAxis = 0;
        if (props.data) {
            let header = [];
            let subHeader = [];
            // let legends = [];
            let data = props.data.tableData;
            if (data) {
                setTableData(data);
                Object.keys(data).forEach(function (key,index) { //setting table header and grahp legends
                    if (typeof (data[key]) !== 'number') {
                        if (key !== 'perHourTotal') {
                            header.push(key);
                            subHeader.push(key);                           
                            legends.push(key);
                        }
                    }
                });               
                header.push('perHourTotal');
                setTableHeader(header);
                findDashed(subHeader);

                // calculating the max value for the YAxis to calculate the fontSize
                let maxSum = [];
                let series = getSeries();
                series.forEach(function(row){
                    if(row.data) {
                        row.data.forEach(function(val, ind) {
                            if(!maxSum[ind])
                                maxSum[ind] = 0;
                            
                            maxSum[ind] += isNaN(parseInt(val))  ? 0 : parseInt(val);
                        });
                    }
                })
                maxYAxis = Math.max(...maxSum);
            }

        } else {
            legends = [];
            setTableData([]);
            setTableHeader([]);
            setmyOptions({});
        }
        myOptionFunction(maxYAxis);

    }, [props.data])

    //This methos is use for create chart ...  start
    function myOptionFunction(maxYAxis) {
        setmyOptions({
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    show: false,
                    type: 'none'
                },
                textStyle: {
                    fontSize:10,
                }
            },
            title: {
                text: 'FHWA 13-bin vehicle classification',
                bottom: '120px',
                left: '40%',
                textStyle: {
                  fontSize: 14,
                }
              },
            legend: {         
                icon:'roundRect',      
                orient:'vertical',
                data: legends ? legends : null,
                bottom: '0px',
                width:'872px',
                height:'100px',
                align : 'auto',
                itemGap : 20,                                
                textStyle: {
                    fontSize: 10,
                },
                formatter: function (name) {
                    let index = headerClassBase.indexOf(name);                    
                    return headerClassChart[index];
                }                
            },
            grid: {
                bottom: '200px',
                height: 'auto',
                top: '20px',
                left: '40px',
                right: '15px',
            },
            xAxis: {
                axisLabel: {
                    rotate: 45,
                    fontSize: 10                    
                },
                type: 'category',
                data: timeArr,
                splitLine: {
                    show: true,
                    lineStyle: {              
                      color: '#F4F4F5',              
                      width: 1
                    }
                },                
                axisLine : {
                    show : false
                },
                axisTick : {
                    show : false
                }
            },
            yAxis: {
                type: 'value',               
                splitLine: {
                    show: true,
                    lineStyle: {              
                      color: '#F4F4F5',              
                      width: 1
                    }
                },                
                axisLine : {
                    show : false
                },
                axisTick : {
                    show : false
                },
                axisLabel: {                    
                    // fontSize: sessionStorage.getItem('midTabWidth') >= 1200 && sessionStorage.getItem('midTabWidth') <= 3500 ? 13 : sessionStorage.getItem('midTabWidth') >= 3501 ? 24 : 12,
                    fontSize: 10
                },
            },
            series: props.data ? getSeries() : []
        })
    }
    //This methos is use for create chart ...  end


    //This method is use to create series to echart bars .... start
    const getSeries = () => {
        let series = [];
        let legendsColor = ["#BFDBFE", "#60A5FA", "#2563EB", "#1E40AF", "#A7F3D0", "#34D399", "#059669", "#006600", "#065F46", "#FDE68A", "#FBBF24", "#D97706", "#92400E", "#FECACA", "#F87171", "#262626"];
        if (legends.length > 0) {
            for (let i = 0; i < legends.length; i++) {
                series.push({
                    name: legends[i],
                    type: 'bar',
                    itemStyle: {
                        color: legendsColor[i],
                    },
                    barWidth: '25px',
                    stack: 'five',
                    label: {
                        show: false,
                        position: 'insideRight'
                    },
                    data: comArr(legends[i]),
                })
            }
        }
        return series;
    }
    //This method is use to create series to echart bars .... end

    const comArr = (key) => {
        let arr = [];
        if (props.data.tableData && props.data.tableData[key] && props.data.tableData[key].data) {
            for (let i = 0; i < props.data.tableData[key].data.length; i++) {
                arr.push(props.data.tableData[key].data[i].class_count);
            }
        }
        return arr;
    }

    const findDashed_old = (header) => {
        let dashedCountArr = [];
   
           for (let indexTime = 0; indexTime < timeArr.length; indexTime++) {
           const timeEle = timeArr[indexTime];
           let dashedCount = 0;
           for (let index = 0; index < header.length; index++) {
               const element = header[index];
               
                   if(props.data.tableData[element]["data"][indexTime].class_count == " "){
                       dashedCount ++ ;
                   }
                   
                if(index == (header.length -1)){
                    dashedCountArr.push((header.length)  == dashedCount);
                }
                   
               }
               
           }
           setDashedArray(dashedCountArr);
       }

       const findDashed = (header) => {
        let dashedCountArr = [];
   
           for (let indexTime = 0; indexTime < timeArr.length; indexTime++) {
           const timeEle = timeArr[indexTime];
           let dashedCount = 0;
           let zeroCount = 0;
           for (let index = 0; index < header.length; index++) {
               const element = header[index];
               
                   if(props.data.tableData[element]["data"][indexTime].class_count === " "){
                       dashedCount ++ ;
                   }

                   if(props.data.tableData[element]["data"][indexTime].class_count === 0){
                    zeroCount ++ ;
                   }
               
                if(index == (header.length -1)){
                    if(((header.length)  == dashedCount)){
                        dashedCountArr.push({key: true, value:'--'})
                    }

                   else if(((header.length)  == zeroCount)){
                        dashedCountArr.push({key: true, value:'0'})

                    }else{
                        dashedCountArr.push({key: false, value:'0'})
                    
                    }
                }
                   
               }
               
           }
           setDashedArray(dashedCountArr);
       }

    return (
        <React.Fragment>
            <div className={classes.countsTabMain}>
                <div className='chart-details-classification'>
                    <Card>
                        {myOptions && tableData && <ReactEcharts option={myOptions}  style={{ marginLeft: '0px',height:'100%'}}/>}
                    </Card>
                </div>
                <div className='tb-classification-info-counts-main'>
                    <div className='mainDivBlock'>
                        <TableContainer component={Paper}>
                            <Table className={classes.tableMidBlock} aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="right" className={classes.tableHead}></TableCell>
                                        <TableCell colSpan={15} align="right" className={classes.tableHead} style={{ fontWeight: 'normal' }}>FHWA 13-bin vehicle classification</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align="right" className={classes.tableHeadStart} style={{ width: '120px'}}>Start Time</TableCell>
                                        {tableHeader && tableHeader.length > 0 ?
                                            tableHeader.map((val, index) => {
                                                return (
                                                <>
                                                    <TableCell align="right" className={classes.tableHead} title={val == 'perHourTotal'?'Total':val} style={val == 'perHourTotal'?{ width: '104px'}:{}}>{
                                                        val == 'perHourTotal' ? 'Total' : val == 'NC' ? 'NC' : headerClass[index]
                                                    }
                                                    </TableCell>

                                                </>
                                                )
                                            })

                                            :
                                            <><TableCell colSpan={15} align="right" className={classes.tableHead} style={{ fontWeight: 'normal', width: '85%' }}>NA</TableCell></>
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {timeArr.map((time, index) => {
                                        return (<StyledTableRow>
                                            <TableCell align="right" className={classes.dataTD} style={{ width: '120px'}}>{time}</TableCell>
                                            {
                                                tableHeader && tableHeader.length > 0 ?
                                                    tableHeader.map((val) => {
                                                        if (tableData && tableData[val]) {
                                                            if (tableData[val].data) {
                                                                return (
                                                                    <TableCell align="right" className={classes.dataTD}>{tableData[val].data[index].class_count === " " ? "--" : tableData[val].data[index].class_count}</TableCell>
                                                                )
                                                            } else {
                                                                return (
                                                                    <TableCell align="right" className={classes.dataTD}>{dashedArray[index].key ? dashedArray[index].value : tableData.perHourTotal[index]}</TableCell>
                                                                 )
                                                            }
                                                        }
                                                    })
                                                    :
                                                    <><TableCell colSpan={15} align="right" className={classes.tableHead} style={{ fontWeight: 'normal', width: '85%' }}>NA</TableCell></>
                                            }

                                        </StyledTableRow>)
                                    })
                                    }
                                    <StyledTableRow>
                                        <TableCell align="right" className={classes.dataTD}>Total</TableCell>
                                        {tableHeader
                                            && tableHeader.length > 0 ?
                                            tableHeader.map((val) => {
                                                if (val == 'perHourTotal') {
                                                    return <TableCell align="right" className={classes.dataTD}>{typeof(tableData.allHourTotal) === 'number' ? tableData.allHourTotal : '--'}</TableCell>
                                                } else if (tableData[val] && tableData[val].data) {
                                                    return (tableData[val] && tableData[val].data ?
                                                        <TableCell align="right" className={classes.dataTD}>{tableData[val].classNumberTotal}</TableCell>
                                                        : <TableCell align="right" className={classes.dataTD}></TableCell>)
                                                }

                                            }) :
                                            <><TableCell colSpan={15} align="right" className={classes.tableHead} style={{ fontWeight: 'normal', width: '85%' }}>NA</TableCell></>
                                        }
                                    </StyledTableRow>

                                    <StyledTableRow>
                                        <TableCell align="right" className={classes.dataTD}>Percent</TableCell>
                                        {tableHeader && tableHeader.length > 0 ?
                                            tableHeader.map((val) => {
                                                return (tableData[val] && tableData[val].data ?
                                                    <TableCell align="right" className={classes.dataTD}>{tableData[val].percentage}%</TableCell>
                                                    : <TableCell align="right" className={classes.dataTD}></TableCell>)
                                            }) :
                                            <><TableCell colSpan={15} align="right" className={classes.tableHead} style={{ fontWeight: 'normal', width: '85%' }}>NA</TableCell></>
                                        }
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default ClassificationChart;